export default {"src":"/_next/static/media/uor.4f1ee6f3.svg","height":68,"width":122,"blurWidth":0,"blurHeight":0};